export const ALL_RANKING_TYPES = ['chips', 'hands-played', 'side-bets-won', 'side-bets-profit', 'insomniac'];
export const ALL_RANKING_PROPERTIES = {
    chips: {
        name: 'Chips',
        serverName: 'Chips',
        medalType: 'chips'
    },
    'hands-played': {
        name: 'Hands Played',
        serverName: 'Hands Played',
        medalType: 'hands_played'
    },
    'side-bets-won': {
        name: 'Side Bets Won',
        serverName: 'Side Bets Won',
        medalType: 'sidebets_won'
    },
    'side-bets-profit': {
        name: 'Side Bets Profit',
        serverName: 'Side Bet Score',
        medalType: 'sidebet_tokens'
    },
    insomniac: {
        name: 'Insomniac',
        serverName: 'Insomniac',
        medalType: 'insomniac'
    }
};
export function getRankingTypeFromServerName(rankingServerName) {
    return ALL_RANKING_TYPES.find((rankingType) => ALL_RANKING_PROPERTIES[rankingType].serverName === rankingServerName);
}
